<div class="overview-field-value">
  @if (!overviewField.is_link) {
    <div
      class="overview-field-value__notLink"
      [ngClass]="{'content-has-icon': fieldIcon?.icon}"
    >
      @if (fieldIcon) {
        <i class="{{fieldIcon.icon}}">
          {{fieldIcon.icon_frame}}
        </i>
      }

      @if (!isArrayValue) {
        <span
          class="overview-field-value__notLink-text"
          [ngClass]="{'expired': expired}"
          [innerHTML]="fieldValues[0] && fieldValues[0].value"
        ></span>
      }
      @else {
        <ng-container>
          @for (item of fieldValues; track $index) {
            <span
              class="overview-field-value__item"
              [ngClass]="{'hide-value': $index > 0,
                          'has-show-more': fieldValues.length > 1}"
            >
              @if ($index < 1) {
                <span [innerHTML]="item.value"></span>
              }
            </span>
          }

          @if (fieldValues.length > 1) {
            <button
              (click)="$event.stopPropagation()"
              (menuOpened)="showMore = true;"
              (menuClosed)="showMore = false;"
              [matMenuTriggerFor]="toggleShowMoreFieldValue"
              [matTooltip]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
              [attr.aria-label]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
              class="overview-field-value__show-more text-link"
              mat-button
              type="button"
            >
              <span>
                {{ 'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate }}
              </span>

              <mat-icon
                matButtonIcon
                iconPositionEnd
              >
                expand_more
              </mat-icon>
            </button>
          }

          <mat-menu
            #toggleShowMoreFieldValue="matMenu"
            (click)="$event.stopPropagation()"
            (keydown)="null"
            class="removePaddingInMatMenu overview-show-more-menu-panel"
          >
            <mat-list class="overview-show-more-menu">
              @for (item of fieldValues; track $index) {
                <ng-container>
                  @if ($index > 0) {
                    <mat-list-item>
                      <span class="overview-field-value__item-text" [innerHTML]="item.value">
                      </span>
                    </mat-list-item>
                  }
                </ng-container>
              }
            </mat-list>
          </mat-menu>
        </ng-container>
      }
    </div>
  }
  @else {
    <div class="overview-field-value__link">
      <app-overview-field-link
        [toneDownTextColor]="false"
        [stylingClass]="viewName"
        [items]="linkItems"
        [disableLinks]="linkDisabled"
        [showAllItems]="showAllLinkItems"
        [visibleItemsCount]="linkVisibleItemsCount"
      ></app-overview-field-link>
    </div>
  }
</div>
